export function tagsSwiper() {
    const swiperContainers = document.querySelectorAll('.tags-swiper.swiper');
    
    if (!swiperContainers.length || typeof Swiper === 'undefined') {
        return;
    }

    // Store swiper instances for each container
    const swiperInstances = new Map();
    const breakpoint = 1025;

    const cloneSlides = (wrapper) => {
        // Check if slides are already cloned
        if (wrapper.dataset.cloned === 'true') {
            return;
        }

        // Get all original slides
        const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
        
        if (originalSlides.length === 0) return;

        // Clone each slide multiple times for seamless loop
        // Clone 2-3 times to ensure continuous scrolling
        const cloneCount = 2;
        
        for (let i = 0; i < cloneCount; i++) {
            originalSlides.forEach((slide) => {
                const clone = slide.cloneNode(true);
                clone.classList.add('swiper-slide-clone');
                wrapper.appendChild(clone);
            });
        }

        // Mark as cloned
        wrapper.dataset.cloned = 'true';
    };

    const removeClonedSlides = (wrapper) => {
        if (wrapper.dataset.cloned === 'true') {
            const clonedSlides = wrapper.querySelectorAll('.swiper-slide-clone');
            clonedSlides.forEach((slide) => {
                slide.remove();
            });
            delete wrapper.dataset.cloned;
        }
    };

    const initSwiper = (swiperContainer) => {
        const wrapper = swiperContainer.querySelector('.tags-swiper-wrapper.swiper-wrapper');
        if (!wrapper) return;

        const existingInstance = swiperInstances.get(swiperContainer);

        if (window.innerWidth < breakpoint) {
            // Destroy existing instance if any (for re-initialization)
            if (existingInstance) {
                existingInstance.destroy(true, true);
                swiperInstances.delete(swiperContainer);
            }

            // Remove any existing cloned slides before re-cloning
            removeClonedSlides(wrapper);

            // Clone slides for continuous loop before initializing Swiper
            cloneSlides(wrapper);

            // Force reflow to ensure cloned slides are rendered
            void wrapper.offsetWidth;

            // Initialize Swiper
            const swiperInstance = new Swiper(swiperContainer, {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: true,
                speed: 16000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    reverseDirection: false,
                },
                allowTouchMove: false,
                grabCursor: false,
                watchSlidesProgress: true,
                // Ensure seamless infinite loop
                loopedSlides: 10,
            });

            // Store instance
            swiperInstances.set(swiperContainer, swiperInstance);

            // Force continuous autoplay
            swiperInstance.autoplay.start();
        } else {
            // Destroy Swiper on larger screens
            if (existingInstance) {
                existingInstance.destroy(true, true);
                swiperInstances.delete(swiperContainer);
            }
            
            // Remove cloned slides when destroying
            removeClonedSlides(wrapper);
        }
    };

    // Initialize all containers
    const initAllSwipers = () => {
        swiperContainers.forEach((container) => {
            initSwiper(container);
        });
    };

    // Initialize on load
    initAllSwipers();

    // Re-initialize on resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initAllSwipers, 150);
    });

    // Also listen to media query changes for better performance
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    
    if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', initAllSwipers);
    } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(initAllSwipers);
    }
}
